import { ZIndex } from '~/types/ThemeTypes'
import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { asChakraVariable } from '@mangovoice/design-system'
import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const scrollingInputDropdownStyleParts = [
  'container',
  'vstack',
  'dropdownContainer',
  'dropdownItemsWrapper',
  'dropdownItem',
] as const
const configHelper = createMultiStyleConfigHelpers(
  scrollingInputDropdownStyleParts,
)

export const ScrollingInputDropdownStyle = configHelper.defineMultiStyleConfig({
  baseStyle: {
    container: {},
    vstack: {
      width: '100%',
      position: 'relative',
      gap: '0.25rem',
    },
    dropdownContainer: {
      width: '100%',
      height: 'auto',
      bg: 'bg.panel',
      zIndex: ZIndex.dropdown,
      borderRadius: '0.375rem',
      border: '1px solid',
      borderColor: 'border.default',
      boxShadow: `${asChakraVariable({
        default: 'inset.lg',
      })} 0px 0px 2px 2px`,
      pt: 'calc(0.25rem)',
      px: '0.25rem',
      pb: '0.25rem',
      position: 'absolute',
    },
    dropdownItemsWrapper: {
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
      maxHeight: '30vh',
    },
    dropdownItem: {
      flexDirection: 'row',
      flex: 1,
      h: 'auto',
      p: '0px',
      pr: '0.25rem',
      width: '100%',
      bg: 'transparent',
      alignContent: 'center',
      color: 'fg.default',
      _hover: {
        backgroundColor: 'bg.muted',
      },
      _selected: {
        backgroundColor: 'bg.emphasized',
      },
      _active: {
        backgroundColor: 'bg.emphasized',
      },
      ...textStyles[textStyleKeys.Body2],
    },
  },
})

export const useScrollingInputDropdownStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(
    ScrollingInputDropdownStyle,
    props,
  ) as MultiStyleType<typeof scrollingInputDropdownStyleParts>
}
